import React from "react";
import { X } from "lucide-react";

// Full-screen click-to-preview overlay for the attachment thumbnails shown
// in the Community Kitchen / Flood Relief Camp / Animal Shelter "Attachment
// Details" modals — those modals only ever show small cropped thumbnails,
// so this is the only way to see an attachment at full size.
const ImagePreviewOverlay = ({ src, onClose }) => {
  if (!src) return null;

  return (
    <div
      onClick={onClose}
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.85)",
        zIndex: 20000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "40px",
      }}
    >
      <button
        type="button"
        onClick={onClose}
        title="Close preview"
        style={{
          position: "absolute",
          top: "20px",
          right: "24px",
          width: 36,
          height: 36,
          borderRadius: "50%",
          border: "none",
          background: "rgba(255,255,255,0.15)",
          color: "#fff",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <X size={20} />
      </button>
      <img
        src={src}
        alt="Attachment preview"
        onClick={(e) => e.stopPropagation()}
        style={{
          maxWidth: "90vw",
          maxHeight: "90vh",
          borderRadius: "8px",
          boxShadow: "0 12px 40px rgba(0,0,0,0.5)",
          objectFit: "contain",
        }}
      />
    </div>
  );
};

export default ImagePreviewOverlay;
